import BaseClient from './BaseClient';
import type { AxiosPromise } from 'axios';
import type { Context } from './contextsClient.types';

class ContextsClient extends BaseClient {
    getContexts(teamId: number): AxiosPromise<{ data: Context[] }> {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/contexts`, 'get');
    }
}

export default new ContextsClient();
